import React from "react";
import { Card } from "antd";

const { Meta } = Card;

const ArticleCard = ({ article }) => {
  return (
    <Card
      hoverable
      cover={
        <img
          alt={article.title}
          src={article.image}
          style={{ height: "200px", objectFit: "cover" }}
        />
      }
      style={{ width: "100%" }}
    >
      <Meta
        title={
          <a href={article.link} target="_blank" rel="noopener noreferrer">
            {article.title}
          </a>
        }
        description={`Published on: ${new Date(article.date).toLocaleString()}`}
      />
      <div style={{ marginTop: "10px" }}>
        <div dangerouslySetInnerHTML={{ __html: article.content }}></div>
        <p>
          <strong>Author:</strong> {article.author}
        </p>
        <p>
          <strong>Source:</strong> {article.site}
        </p>
        <p>
          <strong>Tickers:</strong> {article.tickers}
        </p>
      </div>
    </Card>
  );
};

export default ArticleCard;
